import React from "react";
import "./onscroll.scss"; // your section styling
import useInView from "./view"; // your section styling

const OnScroll = ({ nclass, children }) => {
  const [ref, isVisible] = useInView(0.2);

  return (
    <div
      ref={ref}
      className={`onscroll ${nclass || ""} ${isVisible ? "show" : "hidden"}`}
    >
      {children}
    </div>
  );
};

export default OnScroll;
